import React, { useContext } from 'react';
import { shape, bool, number } from 'prop-types';
import { Col } from '@thd-olt-component-react/core-ui';
import { useConfigService } from '@thd-nucleus/experience-context';
import { ProductSetContext } from '../../context/ProductSetContext';
import { LoaderOverlay } from '../Loader/LoaderOverlay';
import { getFlatActiveProducts, getPricingInfo } from '../../helper';
import { Pricing, Promotions, Total, Messaging } from './SummarySubComponents';

export const Summary = ({
  enableApplianceDeliveryCharge,
  enableFreeDeliveryForExchange,
  applianceDeliveryChargeValue,
  isLoading,
  isMobile,
  productGroups
}) => {
  const {
    isCustomerIdentified,
    isExchangeCustomer
  } = useContext(ProductSetContext);

  const applianceDeliveryThreshold = useConfigService('applianceDeliveryThreshold')
    ?? 396;

  const products = getFlatActiveProducts(productGroups);
  const {
    mapExists,
    originalPrice,
    valuePrice,
    promotionalDiscounts,
    dollarOff,
    totalPrice,
    freeShipping,
    showFlatDeliveryFee,
    mapDetail,
    hideTotal
  } = getPricingInfo(
    products,
    enableApplianceDeliveryCharge,
    enableFreeDeliveryForExchange,
    applianceDeliveryChargeValue,
    isExchangeCustomer,
    applianceDeliveryThreshold
  );

  const deliveryFee = showFlatDeliveryFee ? applianceDeliveryChargeValue : 0;

  return (
    <Col fallback="12" className="package-pricing" data-testid="summary">
      <LoaderOverlay isLoading={isLoading} />
      {!hideTotal && (
        <>
          <Pricing
            mapExists={mapExists}
            originalPrice={originalPrice}
            dollarOff={dollarOff}
            valuePrice={valuePrice}
            numItems={products.length}
          />
          <Promotions
            mapPolicy={mapDetail?.mapPolicy}
            promotionalDiscounts={promotionalDiscounts}
            isMobile={isMobile}
          />
          <Total
            freeShipping={freeShipping}
            mapExists={mapExists}
            deliveryFee={deliveryFee}
            totalPrice={totalPrice}
          />
        </>
      )}
      <Messaging
        mapExists={mapExists || mapDetail?.mapSpecialPriceViolation || mapDetail?.mapOriginalPriceViolation}
        mapPolicy={mapDetail?.mapPolicy}
        isCustomerIdentified={isCustomerIdentified}
      />
    </Col>
  );
};

Summary.propTypes = {
  enableApplianceDeliveryCharge: bool,
  enableFreeDeliveryForExchange: bool,
  applianceDeliveryChargeValue: number,
  isLoading: bool.isRequired,
  isMobile: bool.isRequired,
  productGroups: shape({}).isRequired
};

Summary.defaultProps = {
  enableApplianceDeliveryCharge: false,
  enableFreeDeliveryForExchange: false,
  applianceDeliveryChargeValue: 29
};
